export const ADDRESS_BLANK_VALUES = {
  address: '',
  floorNumber: '',
  doorNumber: '',
  building: '',
  streetName: '',
  streetNumber: '',
  postalCode: '',
  city: '',
  province: '',
  provinceShortName: '',
  region: '',
  regionShortName: '',
  country: '',
  countryLongName: '',
  latitude: 0,
  longitude: 0,
};
